
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/how-to-apply-a-b",
      function () {
        return require("private-next-pages/resources/how-to-apply-a-b.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/how-to-apply-a-b"])
      });
    }
  